export const WorkLine = ({
  tacticPoints,
  point2,
  endScrollPoint,
}: {
  tacticPoints: { x: number; y: number; id: string }[];
  point2: { x: number; y: number } | null;
  endScrollPoint: { x: number; y: number } | null;
}) => {
  const BLUE = 'var(--tech-blue-400)';

  return (
    <svg
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 2,
      }}
    >
      {tacticPoints.length > 0 &&
        point2 &&
        endScrollPoint &&
        (() => {
          const midX = (tacticPoints[0].x + point2.x) / 2 + 15;
          const maxY =
            tacticPoints.length > 0
              ? Math.max(...tacticPoints.map((pt) => pt.y))
              : 0;
          return (
            <>
              {tacticPoints
                .filter(
                  (x) =>
                    x.y !== maxY &&
                    x.y > point2.y + 30 &&
                    x.y < endScrollPoint.y - 10
                )
                .map((pt, index) => (
                  <>
                    <circle
                      cx={pt.x}
                      cy={pt.y}
                      r="4"
                      stroke={BLUE}
                      strokeWidth="2"
                      fill={BLUE}
                    />
                    <line
                      key={index}
                      x1={pt.x}
                      y1={pt.y}
                      x2={midX}
                      y2={pt.y}
                      stroke={BLUE}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </>
                ))}
              {maxY > point2.y + 30 && maxY < endScrollPoint.y - 10 && (
                <>
                  <polyline
                    points={`
          ${tacticPoints[0].x},${maxY}
          ${midX},${maxY}
          ${midX},${point2.y}
          ${point2.x},${point2.y}
        `}
                    stroke={BLUE}
                    strokeWidth="2"
                    fill="none"
                  />
                  <circle
                    cx={tacticPoints[0].x}
                    cy={maxY}
                    r="4"
                    stroke={BLUE}
                    strokeWidth="2"
                    fill={BLUE}
                  />
                  <circle
                    cx={point2.x}
                    cy={point2.y}
                    r="4"
                    stroke={BLUE}
                    strokeWidth="2"
                    fill={BLUE}
                  />
                </>
              )}
              {maxY > endScrollPoint.y - 10 && (
                <>
                  <polyline
                    points={`
          ${midX},${endScrollPoint.y - 10}
          ${midX},${point2.y}
          ${point2.x},${point2.y}
        `}
                    stroke={BLUE}
                    strokeWidth="2"
                    fill="none"
                  />
                  <circle
                    cx={point2.x}
                    cy={point2.y}
                    r="4"
                    stroke={BLUE}
                    strokeWidth="2"
                    fill={BLUE}
                  />
                </>
              )}
            </>
          );
        })()}
    </svg>
  );
};
